import React from 'react';
function IconRight() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "22",
    fill: "none",
    viewBox: "0 0 10 22",
    className: "icon-right"
  }, React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 21.75a.75.75 0 010-1.5h5c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25h-5a.75.75 0 010-1.5h5A2.75 2.75 0 019.25 3v16a2.75 2.75 0 01-2.75 2.75h-5z",
    clipRule: "evenodd"
  }));
}
function Arrow() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "10",
    fill: "none",
    viewBox: "0 0 14 10",
    className: "arrow"
  }, React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.94 5.5H.75a.75.75 0 010-1.5h10.19L8.22 1.28A.75.75 0 019.28.22l4 4a.75.75 0 010 1.06l-4 4a.75.75 0 11-1.06-1.06l2.72-2.72z",
    clipRule: "evenodd"
  }));
}
export const Account = _ref => {
  let {
    active
  } = _ref;
  return React.createElement("span", {
    "aria-hidden": "true",
    className: "navbar-account-wrapper ".concat(active ? 'active' : ''),
    "data-testid": "icon-account"
  }, React.createElement(Arrow, null), React.createElement(IconRight, null));
};